import { render, staticRenderFns } from "./BirthYearSelect.vue?vue&type=template&id=9aacee34&scoped=true"
import script from "./BirthYearSelect.vue?vue&type=script&lang=js"
export * from "./BirthYearSelect.vue?vue&type=script&lang=js"
import style0 from "./BirthYearSelect.vue?vue&type=style&index=0&id=9aacee34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aacee34",
  null
  
)

export default component.exports